<template>
  <div class="custodian-view">
    <!-- Vote mode: active toggle + conditional inputs -->
    <div v-if="mode === 'vote'" class="custodian-toggle">
      <Checkbox
        v-model="form.signcustodian"
        :binary="true"
        input-id="signcustodian"
      />
      <label for="signcustodian" style="margin-left: 8px;">
        {{ component.props?.label || 'I am voting for a custodian.' }}
      </label>
    </div>

    <div v-if="mode === 'vote' && form && form.signcustodian" class="custodian-form">
      <div class="field">
        <label>Custodian for</label>
        <InputText v-model="form.custodian" fluid />
      </div>
      <div class="field">
        <label>Their registration number</label>
        <InputText v-model="form.custodianshn" fluid />
      </div>
      <div class="field">
        <label>Total Shares</label>
        <InputNumber
          v-model="form.custodianShares"
          :min-fraction-digits="0"
          :max-fraction-digits="4"
          fluid
        />
      </div>
      <div class="field">
        <label>Total Votes Available</label>
        <span class="bold">{{ (form?.custodianShares || 0) * shareValue }}</span>
      </div>
    </div>

    <!-- Preview / readonly mode: show a placeholder so admins see where the
         question will appear in the ballot. -->
    <div v-if="mode !== 'vote'" class="custodian-preview">
      <div class="field">
        <Checkbox :model-value="false" :binary="true" :disabled="true" />
        <label style="margin-left: 8px;">
          {{ component.props?.label || 'I am voting for a custodian.' }}
        </label>
      </div>
      <div class="field">
        <label>Custodian for</label>
        <InputText :disabled="true" fluid />
      </div>
    </div>
  </div>
</template>

<script setup>
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import Checkbox from 'primevue/checkbox'

defineProps({
  component: { type: Object, required: true },
  shareholder: { type: Object, default: () => ({}) },
  mode: { type: String, default: 'vote' },
  form: { type: Object, default: null },
  shareValue: { type: Number, default: 2 },
  ballotComponents: { type: Array, default: () => [] },
})
</script>

<style scoped>
.custodian-view {
  padding: 10px 0;

  .custodian-toggle {
    color: #c33;
    margin-bottom: 8px;
  }

  .custodian-form {
    padding: 12px 16px;
    border: 1px solid var(--panel-border, #e6e6e6);
    border-radius: 6px;
    background: var(--panel-bg, #fafafa);
    color: var(--panel-text, inherit);
  }

  .field {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 6px;

    label {
      min-width: 180px;
      font-size: 0.9rem;
      color: var(--muted-text, #555);
    }
  }

  .bold {
    font-weight: 700;
    font-size: 18px;
    color: #1679ca;
  }
}
</style>
